import React from 'react';
import { WorkOrderStatus } from '../../../enums/workOrderStatus';
import { STATUS_LABELS, STATUS_ORDER } from '../WorkOrders/constants';
import type { WorkOrderSettings } from '../../../types/InfrastructureManagerTypes';

export const ZOOM_ROW_KEY = 'zoom_to_last_highlighted';

export type ConfigRowKey = WorkOrderStatus | typeof ZOOM_ROW_KEY;

export interface ConfigRowDef {
  key: ConfigRowKey;
  label: React.ReactNode;
  hasColor: boolean;
}

// Statuses that get a pill colour swatch.
const COLORED_STATUSES = new Set([
  WorkOrderStatus.SUBMITTED,
  WorkOrderStatus.SCHEDULED,
  WorkOrderStatus.COMPLETED,
  WorkOrderStatus.ON_HOLD,
  WorkOrderStatus.ARCHIVED,
]);

export const CONFIG_ROWS: ConfigRowDef[] = [
  { key: ZOOM_ROW_KEY, label: 'Zoom to last highlighted work order', hasColor: false },
  ...STATUS_ORDER.map((status) => ({
    key: status,
    label: (
      <>
        Show <strong>{STATUS_LABELS[status].toLowerCase()}</strong> work orders
      </>
    ),
    hasColor: COLORED_STATUSES.has(status),
  })),
];

const DEFAULT_ROW_COLOR = '#827E7E';

// Mirrors the BE defaults; used until the user's settings load, or if they can't.
export const DEFAULT_WORK_ORDER_SETTINGS: WorkOrderSettings = {
  zoomToLastHighlighted: true,
  statuses: {
    [WorkOrderStatus.SUBMITTED]: { visible: true, color: DEFAULT_ROW_COLOR },
    [WorkOrderStatus.SCHEDULED]: { visible: true, color: DEFAULT_ROW_COLOR },
    [WorkOrderStatus.COMPLETED]: { visible: true, color: DEFAULT_ROW_COLOR },
    [WorkOrderStatus.ON_HOLD]: { visible: false, color: DEFAULT_ROW_COLOR },
    [WorkOrderStatus.ARCHIVED]: { visible: false, color: DEFAULT_ROW_COLOR },
  },
};
